import { Input, Schema, Form, Button } from 'rsuite';
import TextField from '../../components/form/textfield';
import { useCallback, useRef, useState } from 'react';
import IconTextField from '../../components/form/icon-textfield';
import { Show, Hide } from 'react-iconly';
import { postSignUp } from '../../core';
import { showToast } from '../../utils/toast';
import { OTPStep } from './components/otp-step';

const { StringType } = Schema.Types;
const model = Schema.Model({
  name: StringType('فرمت نام صحیح نیست.')
    .isRequired('نام خود را وارد کنید.')
    .pattern(
      /^[ آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ\s]+$/,
      'از حروف فارسی استفاده کنید و از اعداد و نشانه ها استفاده نکنید.'
    ),
  family: StringType('فرمت نام خانوادگی صحیح نیست.')
    .isRequired('نام خانوادگی خود را وارد کنید')
    .pattern(
      /^[ آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ\s]+$/,
      'از حروف فارسی استفاده کنید و از اعداد و نشانه ها استفاده نکنید.'
    ),

  mobile_number: StringType('فرمت شماره موبایل صحیح نیست.')
    .pattern(/09[0-9]{9}$/, 'شماره موبایل باید شامل صفر و یازده رقمی انگلیسی باشد.')
    .isRequired('کد یکبار مصرف را وارد کنید.'),

  national_code: StringType('فرمت کد ملی صحیح نیست.')
    .isRequired('کد ملی را وارد کنید.')
    .pattern(/[0-9]{10}$/, 'کد ملی باید شامل ده رقم انگلیسی باشد.')
    .addRule((e) => {
      const t = e.length;
      let i = 0;
      let n = 0;
      let r = 0;
      if (t < 8 || 0 === parseInt(e, 10)) return !1;
      if (((e = ('0000' + e).substr(t + 4 - 10)), 0 === parseInt(e.substr(3, 6), 10))) return !1;
      for (n = parseInt(e.substr(9, 1), 10), i = 0, r = 0; r < 9; r++) {
        i += parseInt(e.substr(r, 1), 10) * (10 - r);
      }
      return ((i %= 11) < 2 && n === i) || (i >= 2 && n === 11 - i);
    }, 'کد ملی را صحیح وارد کنید'),

  password: StringType('فرمت پسورد صحیح نیست.')
    .pattern(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      'پسورد هشت رقمی شما باید شامل حروف کوچک و بزرگ و اعداد باشد.'
    )
    .isRequired('پسورد را وارد کنید.')
});

export const SignUp = () => {
  const [step, setStep] = useState<'signUp' | 'otp'>('signUp');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>({});

  const handleSubmit = useCallback(async () => {
    if (formRef.current && !formRef.current.check()) {
      console.log('formError', formError);
      return;
    }
    console.log('submitted', formValue);
    // return;
    setLoading(true);
    try {
      const { data, status } = await postSignUp(formValue);
      if (status === 200) {
        if (data.state === 'error') {
          showToast(data.message, 'error');
        } else {
          setStep('otp');
        }
      }
      console.log(data, status);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }, [formValue, formError, formRef]);

  return (
    <div className="pt-3 px-3">
      {step === 'signUp' ? (
        <>
          <h1 className="text-base text-center font-normal">
            برای ساخت حساب کاربری فرم زیر را پر کنید
          </h1>
          <Form
            ref={formRef}
            onChange={setFormValue}
            onCheck={setFormError}
            formError={formError}
            model={model}
            onSubmit={handleSubmit}
            className="w-[90%] mx-auto pb-3">
            <TextField accepter={Input} type="text" name="name" label="نام خود را وارد کنید" />
            <TextField
              accepter={Input}
              type="text"
              name="family"
              label="نام خانوادگی را وارد کنید"
            />
            <TextField
              accepter={Input}
              type="number"
              name="mobile_number"
              label="شماره تماس"
              placeholder="09123456789"
              dir="ltr"
            />
            <TextField
              accepter={Input}
              type="text"
              dir="ltr"
              name="national_code"
              label="کد ملی خود را وارد کنید"
            />
            <IconTextField
              name="password"
              label="یک پسورد برای حسابتان وارد کنید"
              type={visible ? 'text' : 'password'}
              accepter={Input}
              dir="ltr"
              onIconCLick={() => setVisible(!visible)}
              eyeVisible={visible}
              onIcon={<Hide size="small" />}
              offIcon={<Show size="small" />}
            />
            <Button appearance="primary" className="w-full mt-5" type="submit" loading={loading}>
              ساخت حساب کاربری
            </Button>
          </Form>
        </>
      ) : (
        <OTPStep
          type="otp"
          userData={{ mobile_number: formValue.mobile_number, password: formValue.password }}
        />
      )}
    </div>
  );
};
